export function getBiggestValidValue(number: number, limit: number): number {
  const strNumber = number.toString();
  const digitsToExtract = Math.floor(Math.log10(limit)) + 1;
  let lastDigits = parseInt(strNumber.slice(-digitsToExtract), 10);

  while (lastDigits >= limit) {
    lastDigits = parseInt(lastDigits.toString().slice(1), 10);
  }

  return lastDigits;
}
